/* eslint-disable react/no-multi-comp */
import React from 'react';
import useOnClickOutside from '../components/hooks/useOnClickOutside';
import './styles/menuItemVerticalPopoverMenu.scss';

const MenuItemVerticalPopoverMenu = ({
    id,
    editCampaign,
    deleteCampaign,
}: {
    id: number;
    editCampaign: (id: number) => void;
    deleteCampaign: (id: number) => Promise<void>;
}) => {
    const [show, setShow] = React.useState(false);
    const container = React.useRef(null);
    useOnClickOutside(container, () => setShow(false));

    const _edit = () => {
        editCampaign(id);
        setShow(false);
    };

    const _delete = async () => {
        const confirmation = confirm(
            `Are you sure you want to delete this campaign? This cannot be undone.`,
        );

        if (!confirmation) return;

        await deleteCampaign(id);
        setShow(false);
    };

    return (
        <div ref={container}>
            <div
                className="menuItemEllipsisContainer"
                onClick={() => setShow(true)}
            >
                <i
                    className="fas fa-ellipsis-v"
                    aria-hidden="true"
                    style={{ cursor: 'pointer' }}
                />
            </div>
            {show && (
                <div className="menuItemVerticalPopoverMenu">
                    <div
                        className="menuItemVerticalNavigationItem edit"
                        onClick={_edit}
                    >
                        <i className="far fa fa-pencil" />
                        <div className="navigationItem">Edit Campaign</div>
                    </div>
                    <div
                        className="menuItemVerticalNavigationItem delete"
                        onClick={_delete}
                    >
                        <i className="far fa fa-trash" />
                        <div className="navigationItem">Delete</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MenuItemVerticalPopoverMenu;
